<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Danh sách tin tức</h4>
          </div>
          <div class="text-right">
            <div>
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                round
                class="btn-default"
                >Ẩn/hiện tìm kiếm</el-button
              >
              <el-button
                round
                class="btn-default"
                @click="fn_handle('create')"
                v-if="mData.dataDefault.listFeature.includes('FT2202')"
                >Thêm mới</el-button
              >
            </div>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-search">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="mb-3"
            >
              <el-card>
                <el-form
                  ref="mySearchForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="120px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Tiêu đề bài viết gồm">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.title"
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Danh mục tin tức">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value.category_id
                          "
                          clearable
                          placeholder=""
                        >
                          <el-option
                            v-for="item in listNewsCategory"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Nổi bật">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value.is_important
                          "
                          clearable
                          placeholder=""
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listOutStanding"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Tác giả">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.creator_id"
                          clearable
                          filterable
                          placeholder=""
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listEmployee"
                            :key="item.id"
                            :label="`${
                              item.employee_no ? item.employee_no + ' -' : ''
                            } ${
                              item.administrative_info &&
                              item.administrative_info.name &&
                              item.administrative_info.name.full_name
                                ? item.administrative_info.name.full_name
                                : ''
                            }`"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Trạng thái tin tức">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.status"
                          clearable
                          placeholder=""
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listNewsStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Ẩn">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.disabled"
                          clearable
                          placeholder=""
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listOutStanding"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      round
                      class="btn-default"
                      native-type="submit"
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <!-- Start config Document Category -->
            <div
              class="text-right"
              v-if="mData.dataDefault.listFeature.includes('FT2206')"
            >

              <el-button style="margin-bottom:4px;"
                type="text"
                @click="fn_goToConfigNewsCategory"
                title="Cài đặt danh mục tin tức"
              >
                <span>Danh mục tin tức</span>
              </el-button>
              <!-- <i
                class="icon isax-setting-2"
                @click="fn_goToConfigNewsCategory"
                title="Cài đặt danh mục tin tức"
              ></i> -->
              <!-- <el-dropdown trigger="click" @command="fn_goToConfigNewsCategory">
                <i class="icon isax-setting-2" title="Cài đặt danh mục tin tức"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-caret-right" command="doc-type"
                    >Danh mục tin tức</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
            <!-- End config Document Category -->
            <el-table
              :data="mData.tableRules.data"
              border
              @sort-change="fn_tableSortChange"
              style="width: 100%"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="title"
                label="Tiêu đề bài viết"
                min-width="250"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.title ? scope.row.title : ''"
                  >
                    <div class="content" slot="reference">
                      <span class="content">
                        {{ scope.row.title ? scope.row.title : "" }}</span
                      >
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="category_name"
                label="Danh mục tin tức"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="
                      scope.row.category_name ? scope.row.category_name : ''
                    "
                  >
                    <div class="content" slot="reference">
                      <span class="content">
                        {{
                          scope.row.category_name ? scope.row.category_name : ""
                        }}</span
                      >
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="name"
                label="Nội dung bài viết"
                min-width="250"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.content ? scope.row.content : ''"
                  >
                    <div class="content" slot="reference">
                      <span class="content">
                        {{ scope.row.content ? scope.row.content : "" }}</span
                      >
                    </div>
                  </el-popover>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="publish.publish_time"
                label="Thời điểm đăng bài"
                min-width="135"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="
                      scope.row.publish && scope.row.publish.publish_time
                        ? fn_formatDateTime(scope.row.publish.publish_time)
                        : ''
                    "
                  >
                    <div class="content" slot="reference">
                      <span class="content">
                        {{
                          scope.row.publish && scope.row.publish.publish_time
                            ? fn_formatDateTime(scope.row.publish.publish_time)
                            : ""
                        }}</span
                      >
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="creator_name"
                label="Tác giả"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="
                      scope.row.creator_name ? scope.row.creator_name : ''
                    "
                  >
                    <div class="content" slot="reference">
                      <span class="content">
                        {{
                          scope.row.creator_name ? scope.row.creator_name : ""
                        }}</span
                      >
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="status_name"
                label="Trạng thái"
                min-width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="
                      scope.row.status_name ? scope.row.status_name : ''
                    "
                  >
                    <div
                      :class="{
                        'content status-block': true,
                        waiting_approver:
                          scope.row.status == 'WAITING_APPROVER',
                        request_edit: scope.row.status == 'REQUEST_EDIT',
                        approver: scope.row.status == 'APPROVERED',
                      }"
                      slot="reference"
                    >
                      <span class="content">
                        {{
                          scope.row.status_name ? scope.row.status_name : ""
                        }}</span
                      >
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="Nổi bật" width="80" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.is_important"
                    @change="
                      fn_changeOutstanding(scope.row.id, scope.row.is_important)
                    "
                    :disabled="
                      (!mData.dataDefault.listFeature.includes('FT2203') &&
                        !mData.dataDefault.listFeature.includes('FT2204') &&
                        !scope.row.is_creator) ||
                      (!scope.row.is_creator &&
                        !mData.dataDefault.listFeature.includes('FT2203')) ||
                      (!mData.dataDefault.listFeature.includes('FT2203') &&
                        !mData.dataDefault.listFeature.includes('FT2204'))
                    "
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Ẩn" width="50" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.disabled"
                    @change="
                      fn_changeTrangThaiKhoa(scope.row.id, scope.row.disabled)
                    "
                    :disabled="
                      (!mData.dataDefault.listFeature.includes('FT2203') &&
                        !mData.dataDefault.listFeature.includes('FT2204') &&
                        !scope.row.is_creator) ||
                      (!scope.row.is_creator &&
                        !mData.dataDefault.listFeature.includes('FT2203')) ||
                      (!mData.dataDefault.listFeature.includes('FT2203') &&
                        !mData.dataDefault.listFeature.includes('FT2204'))
                    "
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="160px"
                v-if="mData.dataDefault.listFeature.includes('FT2201')"
              >
                <template slot-scope="scope">
                  <el-button
                    class="btn-action"
                    icon="icon24-EyeOn"
                    v-b-popover.hover.left="aLang.c_view"
                    @click="fn_handle('detail', scope.$index, scope.row)"
                  ></el-button>
                  <el-button
                    v-if="mData.dataDefault.listFeature.includes('FT2204') && scope.row.is_creator"
                    class="btn-action ml-0"
                    icon="icon24-VB_ChoKyDuyet"
                    v-b-popover.hover.left="aLang.c_update"
                    @click="fn_handle('update', scope.$index, scope.row)"
                    :disabled="scope.row.status == 'APPROVERED' || scope.row.status == 'WAITING_APPROVER'"
                  ></el-button>
                  <el-button
                    v-if="mData.dataDefault.listFeature.includes('FT2205')"
                    class="btn-action ml-0"
                    icon="icon24-Delete"
                    v-b-popover.hover.left="aLang.c_delete"
                    @click="fn_handle('delete', scope.$index, scope.row)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-4">
                <!-- <div v-if="mData.tableRules.allowSelect">
                  {{ aLang.c_select }}:
                  {{ mData.tableRules.recordSelected.length }}
                </div> -->
              </div>
              <div class="col-md-8 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <el-image-viewer
      class="dialog__image-viewer"
      v-if="visibleDialogImage"
      :on-close="closeViewer"
      :url-list="[imgUrl]"
    />
  </div>
</template>

<script>
import LanguageService from "../../../../service/LanguageService";
import DataService from "../../../../service/DataService";
import MethodService from "../../../../service/MethodService";
import EmployeeApi from "../../../../moduleApi/EmployeeApi";
import NewsApi from "../../../../moduleApi/NewsApi";
import NewsCategoryApi from "../../../../moduleApi/NewsCategoryApi";
import NewsListModel from "./NewsListModel";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        id: null,
        viewMode: "create",
        moduleName: "News", //required
        dataForm: MethodService.copyObject(NewsListModel.dataForm),
        validForm: NewsListModel.validForm,
        tableRules: MethodService.copyObject(NewsListModel.tableRules),
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listTrangThaiKhoa: DataService.listTrangThaiKhoa,
          listNewsStatus: NewsListModel.listNewsStatus,
          listOutStanding: NewsListModel.listOutStanding,
          listEmployee: [],
        },
        currentUser: MethodService.getCurrentUser(),
        currentCompany: MethodService.getCompanyInfo(),
        fileUploadOption: {
          dialogImageUrl: "",
          dialogVisible: false,
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
      imgUrl: "",
      loadImage: false,
      visibleDialogImage: false,
      listNewsCategory: [],
    };
  },

  methods: {
    async fn_getListEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        filters: "disabled=false",
        limit: 9999,
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.dataDefault.listEmployee = [
          {
            id: this.mData.currentCompany.id,
            administrative_info: {
              name: {
                full_name: this.mData.currentCompany.name.name_vi,
              },
            },
          },
          ...employeeApiRes.result,
        ];
      }
    },

    async fn_getListNewsCategory() {
      const newsCategoryApiRes = await NewsCategoryApi.list({
        limit: 9999,
      });
      if (newsCategoryApiRes.result) {
        this.listNewsCategory = newsCategoryApiRes.result;
      }
    },

    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.page = this.mData.tableRules.page;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              ...dataFilter,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      let res = await NewsApi.list(dataFilter);
      this.mData.tableRules.total = res.meta.total;
      if (res.result && res.result.length > 0) {
        let resData = await this.fn_changeData(res.result);
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
        await this.fn_reRender(resData);
      } else {
        this.mData.tableRules.data = [];
        if (
          this.mData.tableRules.offset == this.mData.tableRules.total &&
          this.mData.tableRules.page > 1
        ) {
          this.mData.tableRules.page = this.mData.tableRules.page - 1;
          this.mData.tableRules.offset =
            (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
          await this.fn_initTable();
        }
      }
    },

    fn_reRender(resData) {
      this.mData.tableRules.data = resData;
      if (
        this.mData.tableRules.offset == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1;
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      resData.forEach((item) => {
        item.is_creator = (item.creator_id == this.mData.currentUser.id || this.mData.currentCompany.id == this.mData.currentUser.id)
        if (item.category_id) {
          const category = this.listNewsCategory.find(
            (o) => o.id == item.category_id
          );
          item.category_name = category ? category.name : "";
        }
        if (item.creator_id) {
          const person = this.mData.dataDefault.listEmployee.find(
            (o) => o.id == item.creator_id
          );
          item.creator_name =
            person &&
            person.administrative_info &&
            person.administrative_info.name &&
            person.administrative_info.name.full_name
              ? person.administrative_info.name.full_name
              : item.creator_id == this.mData.currentCompany.id
              ? this.mData.currentCompany.name.name_vi
              : "";
        }
        item.status_name =
          item.status == "WAITING_APPROVER"
            ? "Chờ duyệt"
            : item.status == "REQUEST_EDIT"
            ? "Yêu cầu chỉnh sửa"
            : item.status == "APPROVERED"
            ? "Đã duyệt"
            : "";
      });
      return resData;
    },

    fn_tableSearch() {
      let data = this.mData.tableRules.dataSearch.value;
      data.title = data.title ? data.title.trim() : "";
      data.content = data.content ? data.content.trim() : "";
      this.$refs["mySearchForm"].validate(async (valid) => {
        if (!valid) return false;
        this.mData.tableRules.filters = MethodService.filterTable(
          JSON.stringify(this.mData.tableRules.dataSearch)
        );
        this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
          "company_id=system",
          "company_id:is_null:true"
        );
        this.mData.tableRules.offset = 0;
        this.fn_initTable();
      });
    },

    //event table
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.page = 1;
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    async fn_changeTrangThaiKhoa(id, trangThai) {
      let data = {
        id: id,
        disabled: trangThai,
      };
      try {
        await NewsApi.update(data);
        await this.fn_initTable();
      } catch (error) {
        console.log(error);
      }
    },

    async fn_changeOutstanding(id, isOutstanding) {
      let data = {
        id: id,
        is_important: isOutstanding,
      };
      try {
        await NewsApi.update(data);
        await this.fn_initTable();
      } catch (error) {
        console.log(error);
      }
    },

    fn_handle(type, scope, row) {
      if (type == "create") {
        this.mData.viewMode = "create";
        this.$router.push({
          name: "Admin-News-create",
        });
      } else if (type == "detail") {
        this.$router.push({
          name: "Admin-News-detail",
          params: { id: row.id },
        });
      } else if (type == "update") {
        this.mData.id = row.id;
        this.$router.push({
          name: "Admin-News-update",
          params: { id: row.id },
        });
      } else if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    async fn_delete(id) {
      try {
        await NewsApi.delete(id);
        this.fn_initTable();
        this.mData.viewMode = "create";
      } catch (error) {
        if (error && error.code && error.code === 500) {
          window.toastr.error(error.detail);
        } else {
          window.toastr.error("Xóa thất bại");
        }
      }
    },

    fn_goToConfigNewsCategory() {
      this.$router.push({
        name: "Admin-NewsCategory-list",
      });
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },

    fn_formatDateTime(val) {
      return MethodService.formatDate(val, "timedate");
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      } else if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }

      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        )
        let m1 = this.mData.tableRules.filters.match(/\$vn_text=([^&]*)(&|$)/);
        if (m1) {
          this.$set(this.mData.tableRules.dataSearch.value, 'title', decodeURIComponent(m1[1]));
        }
      }
    },
  },

  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_getListEmployee();
    await this.fn_getListNewsCategory();
    await this.fn_initTable();
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.2s ease;
}
.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.icon {
  cursor: pointer;
}
::v-deep .btn-action {
  background: transparent;
  border: none;
  .icon24-EyeOn {
    color: #606266;
  }
  .icon24-VB_ChoKyDuyet {
    color: var(--blue);
  }
  .icon24-Delete {
    color: var(--red);
  }
  &:hover {
    background: transparent;
    color: inherit;
  }
}
::v-deep .btn-action.is-disabled {
  .icon24-VB_ChoKyDuyet {
    color: #bebebe;
  }
}
::v-deep .isax-setting-2 {
  transition: 0.2s ease;
  &:hover {
    color: var(--orange);
  }
}
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
::v-deep .content {
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .time-attendance-photo {
  margin-bottom: 15px;
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
.upload-demo {
  width: 94px;
  margin: 0 auto;
  margin-top: 10px !important;
}
.upload-demo .el-upload .el-button {
  padding: 5px 23px;
  border-radius: 5px !important;
}
.avatar__image {
  max-width: 300px;
  max-height: 250px;
  :hover {
    cursor: pointer;
  }
}
.status-block {
  width: fit-content;
  padding: 3px 10px;
  margin: auto;
}
.waiting_approver {
  color: #3db82b;
  background: #cef1c2;
  border-radius: 5px;
}
.request_edit {
  color: #ff8800;
  background: #ffc31d4b;
  border-radius: 5px;
}
.approver {
  color: white;
  background: #6bc457;
  border-radius: 5px;
}
</style>
